module.exports = __webpack_public_path__ + "static/media/galdinsLose_5000_10000.fdd58cbf.png";